module.exports = __webpack_public_path__ + "static/media/prepaid_a05.b42e80a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/prepaid_a05.png
// module id = 733
// module chunks = 21